
import { GOOGLEPLAY_LINK } from '@/constants/links'
import Image from 'next/image'
import Link from 'next/link'
import { GA_EVENTS } from '@/utils/analytics'

const GoogleButton = () => {
  const handleClick = () => {
    GA_EVENTS.DOWNLOAD_START('android')
    GA_EVENTS.BUTTON_CLICK('google_download')
  }

  return (
    <Link
      href={GOOGLEPLAY_LINK}
      className='border gap-2 w-[153px] h-[50px] sm:w-[156px] sm:h-[56px] flex items-center justify-center bg-pure-white rounded-5xl px-2 py-1'
      onClick={handleClick}
    >
      <Image src={'/images/Google.svg'} alt="google" width={27} height={27} className='w-[23px] sm:w-[27px]' />
      <p className='text-pure-black text-sm sm:text-[16px]'>Google Play</p>
    </Link>
  )
}

export default GoogleButton
